import React, { useEffect, useState } from 'react';
import ContactUs from '../../../components/LandingPage/ContactUs/ContactUs';
import { Footer } from '../../../components/LandingPage/footer';
import { properties as cases } from "../../../data/successCases";
import SuccessCaseDetails from './components/SuccessCaseDetails';
import SuccessCaseTimeline from './components/SuccessCaseTimeline';
import styles from './cases.module.scss';
import { getI18nPaths, getI18nProps } from '../../../lib/next-i18next/getStatic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { TopbarLanding } from '../../../components/LandingPage/topbar';
import { Contact } from '../../../components/LandingPage/Contact';
import WhatsAppButton from '../../../components/WhatsAppButton';
import { FaceLiftGlobalStyle } from '../../../styles/theme';

// Components

const Cases = ({ activeCase, successCases }) => {
    const isEven = value => value % 2 === 0;

    const router = useRouter();
    const locale = router.query?.locale;
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

    useEffect(() => {
        if (activeCase) {
            setTimeout(() => {
                document.querySelector(`#case-${activeCase}`).scrollIntoView();
            }, 1000)
        }
    }, [activeCase]);

    const actualCase = activeCase ? successCases[activeCase - 1] : {};
    const clientName = actualCase?.clientName?.[locale];
    const disclaimer = actualCase?.disclaimer?.[locale];

    return (
        <>
            <Head>
				<title>Verzel - Casos de Sucesso - {clientName}</title>
				<meta name="title" content={`Verzel - Casos de Sucesso - ${clientName}`} />
				<meta
					name="description"
					content={disclaimer || "Veja os casos de sucesso da Verzel e como eles transformaram a vida das empresas!"}
				/>
			</Head>

            <FaceLiftGlobalStyle />
            <TopbarLanding />

            <div className={styles.container}>
                {successCases?.map((item, index) => (
                    <div
                        id={`case-${item.id}`}
                        key={item.id}
                        className={`${styles.successCaseContainer} ${isEven(index) ? styles.even : styles.odd}`}>
                        <SuccessCaseTimeline successCases={successCases} index={index} />
                        <SuccessCaseDetails {...item} />
                    </div>
                ))}
            </div>

            <WhatsAppButton />
            {mounted && <Contact />}
            <Footer />
        </>
    );

};

export const getStaticProps = async (ctx) => {
    const i18nProps = await getI18nProps(ctx);

    return {
        props: {
            ...i18nProps,
            activeCase: ctx.params.slug,
            successCases: cases
        },
    };
}

export async function getStaticPaths() {
    const casePaths = cases.map((c) => ({ slug: `${c.id}` }));
    const casePathsWithLocale = getI18nPaths(casePaths);

    return {
        paths: casePathsWithLocale,
        fallback: true,
    };
}


export default Cases;
